import React from "react";
import { Instagram, ArrowRight, Globe } from "lucide-react";
import { TEAM, INSTAGRAM_URL, COACHPLUS_URL } from "../data/site";

export default function Social() {
    return (
        <section
            id="social"
            data-testid="social-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 bg-grid opacity-25" />
            <div className="absolute -top-40 right-1/4 w-[420px] h-[420px] rounded-full bg-gold/5 blur-3xl" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-10 relative">
                <div className="max-w-3xl">
                    <div className="font-manrope text-sm uppercase tracking-[0.3em] text-gold mb-4">
                        Social
                    </div>
                    <h2
                        data-testid="social-title"
                        className="font-oswald font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]"
                    >
                        Seguici su
                        <br />
                        <span className="text-shimmer">Instagram.</span>
                    </h2>
                    <p className="mt-6 font-manrope text-zinc-400 text-base sm:text-lg max-w-2xl">
                        Allenamenti, contenuti formativi, dietro le quinte. I profili ufficiali
                        del team RPF e dei singoli coach.
                    </p>
                </div>

                {/* Team RPF official */}
                <div className="mt-12">
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener"
                        data-testid="social-rpf"
                        className="group block relative overflow-hidden rounded-2xl bg-gradient-to-r from-gold/15 via-gold/5 to-transparent border border-gold/30 hover:border-gold transition-all duration-300 hover:shadow-[0_20px_60px_rgba(212,175,55,0.25)]"
                    >
                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 p-6 sm:p-8">
                            <div className="flex items-center gap-5">
                                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gold flex items-center justify-center shadow-[0_8px_24px_rgba(212,175,55,0.4)]">
                                    <Instagram size={26} className="text-ink" />
                                </div>
                                <div>
                                    <div className="font-manrope text-[11px] uppercase tracking-[0.3em] text-gold">
                                        Profilo ufficiale del team
                                    </div>
                                    <div className="font-oswald font-bold text-2xl sm:text-3xl text-white uppercase tracking-wide mt-1">
                                        RPF Coaching
                                    </div>
                                    <div className="font-manrope text-sm text-zinc-300 mt-1">
                                        @rpf_coaching_
                                    </div>
                                </div>
                            </div>
                            <div className="inline-flex items-center gap-2 bg-gold text-ink font-oswald font-bold uppercase tracking-wider px-6 py-3 rounded group-hover:bg-gold-bright transition-colors">
                                Vai al profilo
                                <ArrowRight
                                    size={16}
                                    className="transition-transform group-hover:translate-x-1"
                                />
                            </div>
                        </div>
                    </a>
                </div>

                {/* Coach individual profiles */}
                <div className="mt-6 grid md:grid-cols-3 gap-4 sm:gap-5">
                    {TEAM.map((m, i) => (
                        <a
                            key={m.name}
                            href={m.instagram}
                            target="_blank"
                            rel="noopener"
                            data-testid={`social-coach-${i}`}
                            className="group relative overflow-hidden bg-ink-surface border border-white/10 rounded-xl p-5 hover:border-gold/50 hover:-translate-y-1 transition-all duration-300"
                        >
                            <div className="flex items-center gap-4">
                                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-ink overflow-hidden border border-gold/30">
                                    <img
                                        src={m.logo}
                                        alt={m.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="min-w-0 flex-1">
                                    <div className="font-oswald font-bold uppercase text-white text-sm tracking-wider truncate">
                                        {m.name}
                                    </div>
                                    <div className="font-manrope text-xs text-gold mt-0.5 truncate">
                                        {m.igHandle}
                                    </div>
                                </div>
                                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/10 border border-gold/40 flex items-center justify-center group-hover:bg-gold transition-colors">
                                    <Instagram
                                        size={16}
                                        className="text-gold group-hover:text-ink transition-colors"
                                    />
                                </div>
                            </div>
                            <div className="mt-4 pt-4 border-t border-white/5 flex items-center justify-between">
                                <span className="font-manrope text-[11px] uppercase tracking-widest text-zinc-500">
                                    {m.role}
                                </span>
                                <ArrowRight
                                    size={14}
                                    className="text-zinc-500 group-hover:text-gold group-hover:translate-x-1 transition-all"
                                />
                            </div>
                        </a>
                    ))}
                </div>

                {/* CoachPlus mother site banner */}
                <a
                    href={COACHPLUS_URL}
                    target="_blank"
                    rel="noopener"
                    data-testid="social-coachplus"
                    className="mt-8 group block relative overflow-hidden rounded-xl bg-ink border border-white/10 hover:border-gold/40 transition-all"
                >
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-5 sm:p-6">
                        <div className="flex items-center gap-4">
                            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center">
                                <Globe size={20} className="text-gold" />
                            </div>
                            <div>
                                <div className="font-manrope text-[11px] uppercase tracking-[0.3em] text-zinc-500">
                                    Storefront ufficiale
                                </div>
                                <div className="font-oswald font-bold text-white text-lg uppercase tracking-wide mt-0.5">
                                    Sito Home MR Coaching
                                </div>
                            </div>
                        </div>
                        <div className="inline-flex items-center gap-2 border border-gold/40 text-white font-oswald font-bold uppercase tracking-wider px-5 py-2.5 rounded text-sm group-hover:bg-gold group-hover:text-ink group-hover:border-gold transition-all">
                            Vai al sito
                            <ArrowRight
                                size={14}
                                className="transition-transform group-hover:translate-x-1"
                            />
                        </div>
                    </div>
                </a>
            </div>
        </section>
    );
}
